import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
// import numeral from 'numeral';
import { BigNumber } from 'bignumber.js';
import { Colors } from '../constants';

const Row = styled.div`
  display: flex;
  height: 60px;
  margin-bottom: 2px;
  background: ${props => props.theme.fav.rowBg};
  &:last-child {
    margin-bottom: 0;
  }
`;

const Left = styled.div`
  flex: 1;
  padding: 3px 0 3px 5px;
`;
const Right = styled.div`
  flex: 1;
  padding: 3px 5px 3px 0;
`;

const Base = styled.span`
  color: ${props => props.theme.fav.title};
  font-size: 14px;
`;
const SubBase = styled.span`
  color: ${props => props.theme.fav.title};
  font-size: 10px;
`;

const Price = styled.div`
  color: ${props => props.theme.fav.title};
  font-size: 20px;
  padding-top: 2px;
  margin-bottom: -2px;
`;

const Diff = styled.span`
  color: ${props => (+props.value >= 0 ? Colors.statGreen : Colors.statRed)};
  font-size: 13px;
`;

const DiffPercent = styled.span`
  color: ${props => (+props.value >= 0 ? Colors.statGreen : Colors.statRed)};
  font-size: 13px;
`;

const StatTitle = styled.span`
  color: ${props => props.theme.fav.stat};
  font-size: 12px;
`;

const StatLine = styled.div`
  color: ${props => props.theme.fav.text};
  padding-top: 1px;
  font-size: 12px;
`;

const renderDiff = ({ ticker }) => {
  const hasChange = !!ticker.change;
  const hasPercentage = !!ticker.percentage;
  if (hasChange && hasPercentage) {
    const diff = BigNumber(ticker.change.toString()).toFixed();
    const percentage = BigNumber(ticker.percentage.toString()).toFixed();
    return (
      <div>
        <Diff value={+diff}>{diff}</Diff> <DiffPercent value={+percentage}>{percentage}%</DiffPercent>
      </div>
    );
  }
  return null;
};

const renderStats = ({ ticker }) => {
  const hasHighLow = !!(ticker.high && ticker.low);
  if (hasHighLow) {
    const low = BigNumber(ticker.low.toString()).toString();
    const high = BigNumber(ticker.high.toString()).toString();
    return (
      <div>
        <StatLine>
          <StatTitle>HIGH: </StatTitle>
          {high}
        </StatLine>
        <StatLine>
          <StatTitle>LOW: </StatTitle>
          {low}
        </StatLine>
      </div>
    );
  }
  const bid = BigNumber(ticker.bid.toString()).toString();
  const ask = BigNumber(ticker.ask.toString()).toString();
  return (
    <div>
      <StatLine>
        <StatTitle>BID: </StatTitle>
        {bid}
      </StatLine>
      <StatLine>
        <StatTitle>ASK: </StatTitle>
        {ask}
      </StatLine>
    </div>
  );
};

const FavRow = ({ theme, pair: { exchange, info, ticker } }) => {
  const price = BigNumber(ticker.last.toString()).toString();
  const vol = BigNumber(ticker.baseVolume.toString())
    .integerValue()
    .toString();
  return (
    <ThemeProvider theme={theme}>
      <Row>
        <Left>
          <div>
            <Base>{info.base}</Base>
            <SubBase> / {info.quote}</SubBase>
          </div>
          <Price>{price}</Price>
          {renderDiff({ ticker })}
        </Left>
        <Right>
          <StatLine>{exchange.name}</StatLine>
          {renderStats({ ticker })}
          <StatLine>
            <StatTitle>24H VOLUME: </StatTitle>
            {vol}
          </StatLine>
        </Right>
      </Row>
    </ThemeProvider>
  );
};

export default withTheme(FavRow);



// WEBPACK FOOTER //
// ./src/components/FavRow.js